import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-3xl text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick", "innerHTML"]
const _hoisted_5 = ["textContent"]

import { ref, onMounted, watch } from 'vue'
import { useKuromojiStore } from '@/stores/kuromoji'
import { useSearchStore } from '@/stores/search'
import { furiganaToKuromoji } from '@/utils/analysis'
import { Tokenize } from '@/utils/kuromoji-types'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const kuromoji = useKuromojiStore()
const searchStore = useSearchStore()

const listWords = ref<Tokenize[]>()
const selectedWord = ref('')

const tokenizeListWords = async () => {
  listWords.value = await kuromoji.tokenize(searchStore.keyword)
  selectWord(getFirstWord(listWords.value) || '')
}

const getFirstWord = (tokens: Tokenize[]): string => {
  return tokens.filter(token =>
    token.pos !== '記号' &&
        !(token.surface_form).match(/[a-z]/i) &&
        token.pos_detail_1 !== '空白' &&
        !(token.surface_form).match(/[0-9]/i)
  )[0]?.surface_form || ''
}

const selectWord = (word: string) => {
  selectedWord.value = word
  searchStore.setSelectedWord(word)
}

watch(() => searchStore.keyword, async () => await tokenizeListWords())

onMounted(async () => {
  await tokenizeListWords()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listWords.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "inline-block mt-4 m-1"
      }, [
        ((item.surface_form).match(/[0-9]/i) || (item.surface_form).match(/[a-z]/i))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "japanese_tokenizer_normal",
              innerHTML: _unref(furiganaToKuromoji)(item)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (
                item.surface_form === selectedWord.value
            )
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "japanese_tokenizer_selected",
              innerHTML: _unref(furiganaToKuromoji)(item)
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (
                item.surface_form !== selectedWord.value &&
                item.pos !== '記号' &&
                !(item.surface_form).match(/[a-z]/i) &&
                item.pos_detail_1 !== '空白' &&
                !(item.surface_form).match(/[0-9]/i)
            )
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "japanese_tokenizer",
              onClick: _withModifiers(($event: any) => (selectWord(item.surface_form)), ["stop"]),
              innerHTML: _unref(furiganaToKuromoji)(item)
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (item.pos === '記号' && item.pos_detail_1 === '空白')
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              "data-tooltip": "",
              textContent: _toDisplayString(item.surface_form)
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})